module.exports = __webpack_public_path__ + "static/shape-f9d8f6ea09a9da32ac9b6e0260d4566e.png";